export enum ContractsMutations {
  RESET = "RESET",
  FETCH_CONTRACTS = "FETCH_CONTRACTS",
}
